module.exports = __webpack_public_path__ + "static/media/newsletter-november-2024-2.546f3aee.jpg";